import readableInterval from './readableInterval';

export default (sub) => {
  const planId = sub.applePlanId || sub.planId || sub.stripePlanId;
  return readableInterval(planId);
};
